<template>
  <footer>
    <GridBase class="site-map" dark md>
      <div class="left">
        <router-link to="/" class="logo" />
      </div>
      <ul class="nav">
        <li v-for="depth1 in nav" :key="depth1.route" :class="depth1.isDisabled ? 'disabled' : null">
          <router-link :to="`/${depth1.route}`" v-html="depth1.label" v-bind:class="depth1.class" />
          <ul>
            <li v-for="depth2 in filterNoNav(depth1.children)" :key="depth2.route">
              <router-link :to="`/${depth1.route}/${depth2.route}`" v-html="depth2.label"
                :class="depth2.isDisabled ? 'disabled' : null" />
            </li>
          </ul>
        </li>
        <li class="media" v-if="false">
          <a href="#" target="_blank" class="tv" />
          <a href="#" target="_blank" class="insta" />
        </li>
      </ul>
      <button class="btn-top" @click="moveTop">맨 위로 바로가기</button>
    </GridBase>
    <div class="bottom">
      <div class="ci">
        <a href="https://www.navercorp.com/" class="naver" target="_blank" />
        <a href="https://www.navercloudcorp.com" class="navercloud" target="_blank" />
        <a href="https://www.ncloud.com/" class="ncp" target="_blank" />
      </div>
      <div class="copyright">Copyright @ NAVER corp. All rights reserved.</div>
    </div>
  </footer>
</template>

<script>
import nav from "@/data/nav";
import GridBase from "@/views/components/GridBase";
import _ from "lodash";

export default {
  name: "AppFooter",
  components: { GridBase },
  methods: {
    filterNoNav(list) {
      return _.filter(list, (depth2) => !depth2.noNav);
    },
    moveTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  data() {
    return {
      nav,
    };
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

footer {
  .calibre;

  .site-map {
    .rel;
    .p(50, 0, 60);
    .-box;
    .bgc(#000);

    [grid-base-content] {
      .ib-list;

      .left {
        .w(50%);
        .pl(20);
        .-box;

        .logo {
          .block;
          .wh(36, 36);
          .bg-contain("@{common}/logo.svg");
        }
      }

      .nav {
        color: #fff;
        .w(50%);
        .pl(20);
        .-box;

        a {

          &:active,
          &:hover {
            text-decoration: underline;
          }
        }

        >li {
          .gap-v(18);
          .fs(18);

          &.disabled {
            color: @c-disabled-gray !important;
            pointer-events: none;

            a.outlink::before {
              background-image: url(/img/common/ico-link-disabled.svg);
            }
          }

          >a {
            .medium;

            &.outlink {
              .rel;

              &::before {
                .abs;
                .cnt;
                .rt(-21, 50%);
                .wh(18);
                .mt(-3);
                .yc;
                .bg-contain("@{common}/ico-link.svg");
                .no-repeat;
              }
            }
          }

          >ul {
            .hide;
          }
        }

        .media {
          .abs;
          .lb(50%, -134);
          .pl(20);
          .ib-list;
          z-index: 1;
          .mt(0);

          a {
            .wh(24, 24);
            .gap-h(20);

            &.tv {
              .bg-contain("@{common}/footer-tv.png");
            }

            &.insta {
              .bg-contain("@{common}/footer-insta.png");
            }
          }
        }
      }
    }

    .btn-top {
      .cnt;
      .abs;
      .rb(21, -60);
      .mb(20);
      .wh(30);
      .ir;
      .-a(#4e4e4e, 1);

      &::before {
        .cnt;
        .abs;
        .lt(50%, 50%);
        .wh(12);
        transform: translate(-50%, -50%);
        .bg-contain("@{common}/ico-arrow-top.svg");
        .no-repeat;
      }

      &:hover {
        .bgc(@c-blue);
        border-color: transparent;

        &::before {
          .bg("@{common}/ico-arrow-top_white.svg");
        }
      }
    }
  }

  .bottom {
    .bgc(#141719);
    .p(40, 20);
    .rel;

    .ci {
      .ib-list;

      a {
        .gap-h(20);

        &.naver {
          .wh(69, 13);
          .bg-contain("@{common}/footer-naver.png");
        }

        &.navercloud {
          .wh(126, 15);
          .bg-contain("@{common}/footer-navercloud.png");
        }

        &.ncp {
          .wh(92, 17);
          .bg-contain("@{common}/footer-ncp.png");
        }
      }
    }

    .copyright {
      color: #616161;
      .fs(14);
      .mt(20);
    }
  }
}

@media (min-width: @screen-md-min) {
  footer {
    .site-map {
      .p(100, 0, 20);
      .-box;
      .bgc(#000);

      [grid-base-content] {
        .left {
          .w(25%);
          .pl(40);
          .-box;
        }

        .nav {
          color: #fff;
          .w(75%);
          .pl(0);
          .-box;
          .ib-list;

          >li {
            .w(33.33%);
            .m(0, 0, 52);
            .-box;
            .pl(20);
            .pr(10);

            >ul {
              .block;
              color: @c-light-gray;
              .fs(16);
              .mt(28);

              li {
                .gap-v(16);

                a.disabled {
                  color: @c-disabled-gray !important;
                  pointer-events: none;
                }
              }
            }
          }

          .media {
            .rel;
            .lt;
          }
        }

        .btn-top {
          .r(40);
          .b(-20);
          .mb(73);
        }
      }
    }

    .bottom {
      .p(45, 40, 55);

      .ci {
        .ib-list;
        .abs;
        .lt(50%, 45);
        .pl(20);

        a {
          .gap-h(30);
        }
      }

      .copyright {
        .m(0);
      }
    }
  }
}

@media (min-width: @screen-lg-min) {
  footer {
    .mt(-1);

    .site-map [grid-base-content] {
      .nav {
        >li {
          .mb(63);
        }
      }

      .btn-top {
        .wh(40);
        .mb(63);

        &::before {
          .wh(18);
        }
      }
    }
  }
}

@media (min-width: @screen-xl-min) {
  footer {
    .site-map [grid-base-content] {
      .btn-top {
        .r(80);
      }
    }
  }
}
</style>
